export const checkIsInOperatorConversation = activity =>
  !!(
    activity.entities &&
    activity.entities.length &&
    activity.entities.some(operator => operator.type === 'Operator')
  );

export const hideChatInputFiled = activities => {
  const nodesWithCommand = activities.filter(
    activity =>
      activity.text === '/systemDisabledInputChat' || activity.text === '/systemEnabledInputChat'
  );
  let result = true;
  if (nodesWithCommand && nodesWithCommand.length) {
    const last = nodesWithCommand[nodesWithCommand.length - 1];
    if (last.entities && last.entities.length) {
      if (last.text === '/systemDisabledInputChat') {
        result = false; // hiding
      } else if (last.text === '/systemEnabledInputChat') {
        result = true; // showing
      }
    }
  }
  return result;
};

export const isRichTextString = str => {
  if (!str) return false;
  // Check for both regular and encoded div tags
  return /^<div>.*<\/div>$/.test(str) || /^&#x3C;div&#x3E;.*&#x3C;\/div&#x3E;$/.test(str);
};



// WEBPACK FOOTER //
// ./src/components/MessageHistory/BotMessage/utils.js